import { connect } from 'react-redux';
import Header from './Header';
import { updateNewSearchTextActionCreator } from '../../redux/products-reducer';


let mapStateToProps = (state) => {
  return {
    aboutData: state.aboutPage.aboutData,
    productsPage: state.productsPage
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
    updateNewSearchText: (text) => {
      dispatch(updateNewSearchTextActionCreator(text))
    }, 
  
  }
}

const HeaderContainer = connect(mapStateToProps, mapDispatchToProps)(Header);

export default HeaderContainer;